var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 634.75 369.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#138978;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-17);}.cls-5{fill:#0b6d5c;}.cls-6{fill:#fb968c;}.cls-7{fill:#349fa0;}.cls-8{fill:#a5dff7;}.cls-9{fill:#d9e4f4;}.cls-10{fill:url(#linear-gradient-15);}.cls-11{fill:#41d7d0;}.cls-12{fill:url(#linear-gradient-18);}.cls-13{fill:#79aadd;}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:#1a8481;}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:#ad6600;}.cls-18{fill:#12b6a1;}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:#ea706a;}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:#efa701;}.cls-23{fill:#dd8a05;}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:#11aa94;}.cls-26{fill:#002454;}.cls-27{fill:#275f91;}.cls-28{fill:url(#linear-gradient-5);}.cls-29{fill:#97b5a8;opacity:.48;}.cls-30{fill:#e9f3ff;}.cls-31{fill:url(#linear-gradient-7);}.cls-32{fill:#ffbf49;}.cls-33{fill:url(#linear-gradient-9);}.cls-34{fill:url(#linear-gradient-3);}.cls-35{fill:url(#linear-gradient);}.cls-36{fill:#b25656;}.cls-37{fill:url(#linear-gradient-4);}.cls-38{fill:url(#linear-gradient-8);}.cls-39{fill:#46b7b4;}.cls-40{fill:url(#linear-gradient-12);}.cls-41{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 326.28,
    y1: 101.64,
    x2: 326.28,
    y2: 463.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 331.05,
    y1: -8.63,
    x2: 331.05,
    y2: 448.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4057.96,
    y1: 1455.25,
    x2: 4091.18,
    y2: 1455.25,
    gradientTransform: "translate(4460.99 1546.7) rotate(-143.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e0e9f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e4f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -490.65,
    y1: 1795.11,
    x2: -486.17,
    y2: 1795.11,
    gradientTransform: "translate(1836.64 -547.62) rotate(47.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -515.02,
    y1: 1801.28,
    x2: -493.29,
    y2: 1801.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 448.02,
    y1: 297.61,
    x2: 467.04,
    y2: 297.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e0e9f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 220.21,
    y1: 323.28,
    x2: 224.69,
    y2: 323.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 195.84,
    y1: 329.45,
    x2: 217.57,
    y2: 329.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2726.7,
    y1: 2936.16,
    x2: 2798.73,
    y2: 2990.24,
    gradientTransform: "translate(2506.38 3423.76) rotate(-173.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e4f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2955.76,
    y1: 2730.39,
    x2: 3035.21,
    y2: 2790.04,
    gradientTransform: "translate(2249.65 3556.07) rotate(-165.59)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3145.56,
    y1: 76.74,
    x2: 3178.78,
    y2: 76.74,
    gradientTransform: "translate(3456.79 -303.87) rotate(169.87) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 326.42,
    y1: 286.28,
    x2: 335.75,
    y2: 286.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b25656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b65959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c36562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d87772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f69288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb968c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 327.23,
    y1: 289.51,
    x2: 336.56,
    y2: 289.51,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 328.29,
    y1: 292.53,
    x2: 337.62,
    y2: 292.53,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 207.89,
    y1: 399.8,
    x2: 214.95,
    y2: 399.8,
    gradientTransform: "translate(205.74 -205.36) rotate(6.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b25656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#bb5e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d77671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#eb8880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f79289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb968c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 210.01,
    y1: 402.62,
    x2: 217.07,
    y2: 402.62,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 213.4,
    y1: 405.09,
    x2: 220.46,
    y2: 405.09,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 483.55,
    y1: 329.55,
    x2: 506.36,
    y2: 329.55,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m154.88,354.66s-40.77-29.33-54.63-51.84c-54.18-87.98,1.43-165.37,91.92-164.87,27.92.15,81.14,3.12,101.5,1.15,28.31-2.74,50-50.15,86.31-83.27,99.42-90.72,205.06-9.25,177.86,86.54-12.49,43.98-41.14,76.32-36.15,109.82,8.38,56.16,56.76,60.32,51.61,102.47H154.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m457.33,63.08h97.41s-1.66-5.33-6.63-5.82c-4.97-.49-8.87.68-8.87.68,0,0-1.45-2.61-3.7-3.02-4.45-.81-10.92,1.75-10.92,1.75,0,0,.57-12.65-12.44-13.74-10.79-.91-24.17,11.96-24.17,11.96,0,0-2.27-2.6-5.39-2.79-3.12-.19-10.92,3.61-10.92,3.61,0,0-1.85-2.43-4.29-2.34-2.44.1-7.86,2.86-10.07,9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m188.14,54.48h124.18s-.69-3.43-9.16-3.71c-7.62-.25-13.69.1-16.58-.72-2.88-.82-7.41-5.15-12.87-5.56-5.46-.41-9.58,1.82-18.23,1.13,0,0-2.37-4.53-6.18-5.15-3.81-.62-9.99,2.47-9.99,2.47,0,0-.93-4.22-4.84-4.63-3.91-.41-9.06,2.37-9.06,2.37,0,0,2.27-12.22-11.33-13.87-11.97-1.45-16.89,11.7-17.5,17.68-11.94-5.46-12.36,7.27-8.44,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m343.47,94.59h101.95s-4.69-4.58-12.54-4.69c-7.85-.11-13.36,3.93-16.14,3.16-2.34-1.52-3.71-5.56-7.09-6.43-4.7-1.21-7.85,1.64-7.85,1.64,0,0,.11-4.93-4.36-6-6.26-1.49-10.36,4.25-10.36,4.25,0,0-1.38-8.32-7.41-9.49-12.43-2.4-17.88,10.79-17.88,10.79,0,0,.38-3.84-3.27-4.69-3.47-.8-12.65,1.96-15.05,11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.55,355.27c-.11,0-.22-.03-.32-.09-17.44-10.55-35.77-23.48-51.73-46.37-11.48-16.46-18.09-33.56-19.66-50.81-1.47-16.16,1.51-31.73,8.86-46.26,17.84-35.3,58.26-57.98,105.47-59.21,6.04-.16,12.69-.26,19.73-.37,25.49-.39,54.38-.84,70.02-4.07,14.44-2.99,39.06-32.61,62.76-61.36,10.57-12.83,20.06-24.26,29.03-34.14,23.79-26.2,52.42-43.54,83.06-49.93,28.11-5.86,55.43-1.95,76.91,11.02,17.58,10.61,29.92,26.55,35.68,46.1,6.38,21.64,4.57,46.32-5.37,73.35-5,13.59-13.15,28.44-21.78,44.17-18.37,33.45-37.36,68.05-25.33,91.19,5.27,10.14,18.3,16.23,33.39,23.28,12.11,5.66,25.85,12.08,36.79,21.63,12.57,10.97,19.62,24.44,21.55,41.2.04.34-.2.64-.54.68-.34.04-.64-.2-.68-.54-4.26-36.9-32.62-50.16-57.64-61.86-15.29-7.15-28.5-13.32-33.96-23.83-12.33-23.73,6.82-58.61,25.34-92.35,8.61-15.68,16.74-30.5,21.71-44,18.84-51.24,7.7-95.34-29.79-117.97-39.75-24-106.94-18.41-158.43,38.68-9.38,10.4-19.35,22.45-29,34.1-24.99,30.19-48.6,58.7-63.45,61.78-15.75,3.26-44.7,3.71-70.25,4.1-7.03.11-13.68.21-19.71.37-46.77,1.21-86.78,23.64-104.41,58.53-15.21,30.08-11.4,64.11,10.71,95.83,15.83,22.71,34.04,35.54,51.36,46.02.29.18.38.55.21.84-.12.19-.32.3-.52.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m493.68,66.65h-53.11c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h53.11c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m204.91,61.52h-37.32c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h37.32c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m182.04,68.88h-50.84c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h50.84c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bike"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m330.94,243.82c-5.3,8.92-15.65,35.64-19.67,39.33l7.94,4.61s12.31-17.72,23.53-35.14l-11.8-8.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m332.08,307.05c2.62-3.07-2.44-6.26-3.92-8.87-1.99-3.51-4.82-13.74-4.82-13.74,0,0-2.09-1.71-3.24-1.01-.26.16-.38,1.22-.38,1.22,0,0-2.44.3-3.94-.81-2.51-1.85-2.34-4.02-2.95-4.02-2.62.04-6.57,6.29-6.57,6.29l19.12,18.37,6.71,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m332.08,307.05c-13.47-8.74-15.79-15.85-25.83-20.95l-2.1,2.85c-.42.57-.3,1.37.27,1.8l20.79,15.34s4.9,3.11,6.87.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m306.71,290.58l5.75,4.25c.41.3,1.03.15,1.39-.34v-.02c.37-.49.34-1.13-.07-1.43l-5.75-4.25c-.41-.3-1.03-.15-1.39.34v.02c-.37.49-.34,1.13.07,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m325.48,297.76c-.26,0-.5-.18-.56-.45-.07-.31.12-.62.43-.69l1.96-.45c.31-.07.62.12.69.43.07.31-.12.62-.43.69l-1.96.45s-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.95,293.82c-.26,0-.5-.18-.56-.45-.07-.31.12-.62.43-.69l1.96-.45c.31-.07.62.12.69.43.07.31-.12.62-.43.69l-1.96.45s-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m322.77,290.22c-.26,0-.5-.18-.56-.45-.07-.31.12-.62.43-.69l1.97-.45c.31-.07.62.12.69.43.07.31-.12.62-.43.69l-1.97.45s-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m324.96,289.78c-.1,0-.2,0-.29-.02-.16-.02-.3-.1-.4-.24-.09-.13-.13-.29-.1-.45.34-1.6,2.73-4.07,4.35-4.07.49,0,.91.21,1.19.59.34.46.37,1.01.09,1.56-.68,1.35-3.31,2.61-4.85,2.61Zm3.57-3.62c-.77,0-2.22,1.27-2.89,2.38,1.17-.28,2.77-1.13,3.15-1.89.11-.22.05-.31,0-.36-.06-.08-.12-.13-.27-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m324.35,289.86c-.22,0-.44-.13-.53-.35-.87-2.05.75-5.56,2.51-6.4.29-.14.63-.01.77.27.14.29.01.63-.27.77-1.28.61-2.57,3.45-1.94,4.91.12.29-.01.63-.3.75-.07.03-.15.05-.23.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m308.62,194.62s54.48,11.69,56.52,24.57c1.31,8.27-14.65,30.42-26.25,45.22l-16.86-7.01c2.7-9.72,14.38-25.65,14.38-25.65l-43.57-12.94,15.77-24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m334.95,229.84c-1.55,1.55-3.42,4,1.89,5.35,5.31,1.35,3.96-3.96,3.96-3.96l-5.85-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m319.86,303.55c-.12,0-.25-.04-.36-.12l-10.05-7.94c-.25-.2-.29-.56-.09-.81.2-.25.56-.29.81-.09l10.05,7.94c.25.2.29.56.09.81-.11.14-.28.22-.45.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m331.9,308.6c-.09,0-.18-.02-.27-.07l-16.65-8.73c-.28-.15-.39-.49-.24-.78.15-.28.49-.39.78-.24l16.65,8.73c.28.15.39.49.24.78-.1.2-.3.31-.51.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m179.17,282.49c.16-.9-1.33-1.07-1.6-1.09-1.14-.1-2.84.27-2.89.28l-2.07,2.74s2.22-.3,2.22-.33c0-.03,4.34-1.59,4.34-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m168.07,279.39s.35-.71,1.25-.38c.48.18,2.17,1.26,2.17,1.26l-1.37,2.01-2.05-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m190.84,198.22l-2.51,2.94s28.81,23.47,30.14,34.65c.9,7.53-20.04,27.94-33.83,40.47l-6.76-6.84c7.71-11.31,14.9-24.49,19.78-29.53.1-1.89-43.98-23.44-37.15-38.18,7.9-17.07,23.13-16.62,23.13-16.62l7.2,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m184.64,276.29c-6.69,6.09-11.7,10.32-11.7,10.32l-4.23-5.35c3.07-3.25,6.16-7.39,9.17-11.81l6.76,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m184.64,277.57c-.33,0-.66-.13-.91-.38l-6.76-6.84c-.5-.5-.49-1.32.01-1.81.5-.5,1.32-.49,1.81.01l6.76,6.84c.5.5.49,1.32-.01,1.81-.25.25-.58.37-.9.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m184.75,305.07s-.75-1.37-1.9-2.13c-.88-.58-1.72-1.19-2.54-1.81-2.21-1.67-4.69-7.12-5.22-9.5-.47-2.11-.82-7.03-.82-7.03,0,0,.53-.22-.28-.71-.81-.49-2.39-1.07-3.14-1.66-1.04-.83-2.75-2.9-2.75-2.9,0,0-1.79,3.78-2.49,4.44-.69.66-3.14,2.29-4,2.91-1.3.94-1.88,2.26-1.88,2.26l-.05,1.69,23.75,15.67,1.32-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m181.53,301.96c.46.3.94.58,1.39.88,1.15.75,1.82,2.23,1.82,2.23l-1.32,1.23-2.37-2.51.47-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m184.75,305.07s-3.86-1.16-6.34-2.46c-1.36-.71-17.21-12.18-17.21-12.18l-1.47-1.49s-1.07.75-1.3,1.38c-.23.63-.48.99-.09,1.49.39.5,5.14,3.31,6.42,4.19,1.55,1.06,4.77,4.53,10.44,8.08,2.34,1.46,7.46,4.66,8.77,3.82,1.31-.84,1.57-1.95.77-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m180.42,302.81c-3.27-2.84-6.42-5.72-7.59-8.91-1.25-3.41-.81-6.23.54-10.32.44-.61,5.18-1.6,5.79-1.11-2.26.82-3.87,2.46-4.27,3.83-.56,1.95-.02,4.14.71,6.45,1.14,3.63,4,7.31,4.7,8.08.29.32,1.21,1.13,1.21,1.13.45.75-.47,1.83-.47,1.83,0-.07.02-.41-.63-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m181.06,303.77s0,.02,0,.02v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m171.84,293.44c-.18,0-.35-.08-.46-.23-.19-.25-.14-.61.12-.8.08-.06,1.98-1.45,4.06-.89.31.08.49.4.4.7-.08.31-.4.49-.7.4-1.54-.41-3.06.69-3.07.7-.1.08-.22.11-.34.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m173.46,296.92c-.14,0-.29-.05-.4-.16-.23-.22-.23-.58-.01-.81.07-.07,1.64-1.68,3.58-1.47.32.03.54.32.51.63-.03.32-.32.55-.63.51-1.37-.15-2.62,1.12-2.63,1.13-.11.12-.26.17-.41.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m175.67,299.5c-.12,0-.23-.03-.33-.11-.26-.18-.32-.54-.14-.8.04-.06,1.07-1.49,2.79-1.49h.03c.32,0,.57.26.57.58,0,.32-.26.57-.57.57h-.02c-1.12,0-1.85.99-1.86,1-.11.16-.29.24-.47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m178.22,302.07c-.1,0-.19-.02-.28-.07-.28-.16-.37-.51-.22-.78.08-.14.81-1.37,2.04-1.53.31-.04.6.18.64.49.04.31-.18.6-.49.64-.57.07-1.06.73-1.19.96-.11.19-.3.29-.5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m159.73,288.94l1.47,1.49s11.86,8.58,15.94,11.35l-.09-.06-1.77,2.39s-.05-.03-.07-.04c-5.67-3.55-8.89-7.01-10.44-8.08-1.28-.88-6.03-3.68-6.42-4.19-.39-.5-.14-.86.09-1.49.23-.63,1.3-1.38,1.3-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m172.93,288.84c-.09,0-.19-.02-.27-.07-2.85-1.52-3.57-3.26-3.29-4.38.18-.73.78-1.21,1.5-1.21.48,0,.96.22,1.36.62.59.59,1.28,1.84,1.28,4.47,0,.2-.11.39-.28.49-.09.05-.19.08-.29.08Zm-2.06-4.51c-.19,0-.33.13-.38.34-.12.47.18,1.47,1.83,2.56-.15-1.68-.66-2.38-.9-2.62-.18-.18-.37-.28-.54-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m173.87,289c-.09,0-.17-.02-.25-.06-.07,0-.15,0-.23-.02-.31-.09-.48-.4-.4-.71.16-.57,1.64-5.6,3.81-6.49.55-.23,1.12-.19,1.65.11.71.4,1.07,1.05,1.02,1.81-.12,1.96-2.83,4.24-5.39,5.3-.07.03-.15.04-.22.04Zm3.65-6.27c-.09,0-.18.02-.28.06-1.05.43-2.17,2.84-2.83,4.75,2.27-1.16,3.85-2.93,3.92-3.96.01-.22-.02-.5-.45-.74-.13-.07-.24-.11-.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m174.71,289.38c-.12,0-.23-.04-.34-.11-1.05-.76-2.59,0-2.61,0-.28.14-.63.03-.77-.25-.14-.28-.03-.63.25-.77.09-.05,2.18-1.09,3.8.09.26.19.31.55.13.8-.11.15-.29.24-.47.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m172.6,303.55c-.12,0-.25-.04-.36-.12l-10.05-7.94c-.25-.2-.29-.56-.09-.81.2-.25.56-.29.81-.09l10.05,7.94c.25.2.29.56.09.81-.11.14-.28.22-.45.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m184.64,308.6c-.09,0-.18-.02-.27-.07l-16.65-8.73c-.28-.15-.39-.49-.24-.78.15-.28.49-.39.78-.24l16.65,8.73c.28.15.39.49.24.78-.1.2-.3.31-.51.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m197.78,237.05c-1.82.88-5.08,3.22,0,4.83,5.08,1.61,0-4.83,0-4.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "462.27 276.5 452.17 288.16 456.5 291.82 468.55 282 462.27 276.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m425.11,213.97c-.89,17.85,54.88,37.3,54.88,37.3l-17.41,25.39,6.61,4.71s36.73-25.17,36.73-34.5c0-13.41-45.93-39.09-45.93-39.09l-34.88,6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m456.5,291.11c-.52-.12-1.57-.71-2.15-1.5-1.38-1.89-1.38-2.91-1.61-2.99-.23-.08-2.79,1.4-3.36,3.17-.57,1.77,5.29,4.56,5.29,4.56l1.83-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m466.96,303.26c.14-.21.07-1.06-.88-1.98-5.11-4.99-5.78-11.75-5.78-11.75,0,0-3.89.17-4.74,5.57l5.12,4.26,6.29,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m459.73,298.32c.49,0,3.58-.28,3.24-1.54-1.16-2.48-1.64-5.62-3.04-5.8-1.4-.19-4.51.43-5.7-.49-1.2-.92-2.15-3.58-2.15-3.58,0,0-.76.44-1.17.84,0,0,2.77,5.27,3.07,6,.3.73,5.76,4.58,5.76,4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m466.96,303.26c.38.56-.86,2.19-.86,2.19,0,0-4.79-2.2-8.16-5.1-5.81-4.99-10.13-8.27-9.91-8.68.22-.41,1.35-1.88,1.35-1.88,0,0,5.86,5.14,8.11,6.87,4.58,3.52,9.47,6.6,9.47,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m459.19,290.94c.28,0,.53,0,.74.04,1.4.19,1.88,3.32,3.04,5.8.13.46-.21.88-1.04,1.16-.49-.72-2.1-4.16-2.74-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m461.11,294.93c-.23,0-.45-.14-.54-.37-.11-.3.03-.63.33-.74l.78-.3c.29-.11.63.03.74.33.11.3-.03.63-.33.74l-.78.3c-.07.03-.14.04-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m461.96,297.17c-.21,0-.42-.12-.52-.33-.14-.29-.02-.63.27-.77l.76-.36c.29-.14.63-.02.77.27.14.29.02.63-.27.77l-.76.36c-.08.04-.16.06-.25.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m462.66,273.37c-1.62,1.25-2.66,3.15-2.66,3.15,0,0,2.72,6.36,7.35,7.79,2.02.68,4.61-1.99,4.61-1.99.99-2.96-8.06-9.86-9.3-8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m460.86,303.55c-.12,0-.25-.04-.36-.12l-10.05-7.94c-.25-.2-.29-.56-.09-.81.2-.25.56-.29.81-.09l10.05,7.94c.25.2.29.56.09.81-.11.14-.28.22-.45.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m472.9,308.6c-.09,0-.18-.02-.27-.07l-16.65-8.73c-.28-.15-.39-.49-.24-.78.15-.28.49-.39.78-.24l16.65,8.73c.28.15.39.49.24.78-.1.2-.3.31-.51.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m216.66,199.63c2.2,4.69,27.38,27.54,27.38,27.54,1.86.97,6.26,1.52,5.29,3.38l-9.19.08s-27.69-18.18-31.51-24.68c-3.83-6.51-5.66-16.95-3.64-34.74.62-5.4.36-10.03,4.55-9.68,4.18.35,7.06,4.02,6.94,8.21-.19,6.54-2.01,25.2.19,29.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m241.84,225.45l5.06-.31.61.08h0s.16.08.25.12l.3.12c.21.08.42.15.63.21.42.13.86.22,1.28.27.85.1,1.69.02,2.39-.38l.04-.02c.38-.22.87-.08,1.08.3.18.32.11.72-.14.96-.45.43-.99.76-1.56.99-.57.23-1.16.37-1.74.45-.59.08-1.17.09-1.75.07-.29-.01-.58-.04-.87-.07l-.44-.06c-.15-.03-.28-.04-.48-.1h0s.61.08.61.08l-5.05.44c-.87.08-1.64-.57-1.71-1.44-.08-.87.57-1.64,1.44-1.71.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m250.16,232.8c-1,.25-3.76-2.21-3.76-2.21l3.31.02s1.44,1.94.45,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m247.06,234.45c-2.68-.16-3.29-3.88-3.29-3.88l1.8-.21,1.49,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m208.62,205.95c.21.36.5.76.85,1.19,0,0,.93-3.69,6.99-6.19l-9.74,1c.56,1.48,1.19,2.81,1.89,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m216.47,169.74c.12-4.2-2.76-7.86-6.94-8.21-4.18-.35-3.93,4.27-4.55,9.68-1.7,14.88-.69,24.63,1.93,31.22l.67.93,9.08-3.73c-2.2-4.69-.38-23.35-.19-29.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m207.34,204.73c-.51,0-.98-.3-1.19-.8-.27-.66.05-1.4.7-1.67l9.32-3.81c.66-.27,1.4.05,1.67.7.27.66-.05,1.4-.7,1.67l-9.32,3.81c-.16.07-.32.1-.49.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m118.95,354.53c-25.77,0-46.73-20.96-46.73-46.73s20.96-46.73,46.73-46.73,46.73,20.96,46.73,46.73-20.96,46.73-46.73,46.73Zm0-90.5c-24.13,0-43.77,19.64-43.77,43.77s19.64,43.77,43.77,43.77,43.77-19.64,43.77-43.77-19.63-43.77-43.77-43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.95,349.94c-23.24,0-42.14-18.91-42.14-42.14s18.91-42.14,42.14-42.14,42.14,18.91,42.14,42.14-18.91,42.14-42.14,42.14Zm0-83.14c-22.61,0-41,18.39-41,41s18.39,41,41,41,41-18.39,41-41-18.39-41-41-41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m82.92,308.37c-.32,0-.57-.26-.57-.57,0-20.18,16.42-36.6,36.61-36.6,6.85,0,13.52,1.9,19.31,5.5.27.17.35.52.18.79-.17.27-.52.35-.79.18-5.6-3.49-12.07-5.33-18.7-5.33-19.55,0-35.46,15.91-35.46,35.46,0,.32-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m89.38,299.85c-.05,0-.11,0-.16-.02-.3-.09-.48-.41-.39-.71,3.84-13.34,16.22-22.66,30.12-22.66.32,0,.57.26.57.57s-.26.57-.57.57c-13.39,0-25.32,8.98-29.02,21.83-.07.25-.3.42-.55.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m118.95,339.14c-.32,0-.57-.26-.57-.57s.26-.57.57-.57c13.27,0,25.17-8.87,28.94-21.58.09-.3.41-.48.71-.39.3.09.48.41.39.71-3.92,13.19-16.27,22.4-30.05,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m124.65,333.24c-.26,0-.5-.18-.56-.45-.07-.31.12-.62.43-.69,8.31-1.9,15.21-8.09,17.99-16.16.1-.3.43-.46.73-.36.3.1.46.43.36.73-2.91,8.44-10.13,14.92-18.82,16.91-.04.01-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m118.95,344.41c-2.4,0-4.8-.23-7.14-.7-.31-.06-.51-.36-.45-.68.06-.31.36-.51.67-.45,2.26.45,4.59.67,6.91.67,16.08,0,30.18-10.85,34.28-26.38.08-.31.39-.49.7-.41.31.08.49.4.41.7-4.24,16.03-18.79,27.23-35.39,27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m552.26,354.53c-25.77,0-46.73-20.96-46.73-46.73s20.96-46.73,46.73-46.73,46.73,20.96,46.73,46.73-20.96,46.73-46.73,46.73Zm0-90.5c-24.13,0-43.77,19.64-43.77,43.77s19.64,43.77,43.77,43.77,43.77-19.64,43.77-43.77-19.64-43.77-43.77-43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m552.26,349.94c-23.24,0-42.14-18.91-42.14-42.14s18.91-42.14,42.14-42.14,42.14,18.91,42.14,42.14-18.91,42.14-42.14,42.14Zm0-83.14c-22.6,0-41,18.39-41,41s18.39,41,41,41,41-18.39,41-41-18.39-41-41-41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m516.23,308.37c-.32,0-.57-.26-.57-.57,0-20.18,16.42-36.6,36.6-36.6,6.85,0,13.52,1.9,19.31,5.5.27.17.35.52.18.79-.17.27-.52.35-.79.18-5.6-3.49-12.07-5.33-18.7-5.33-19.55,0-35.46,15.91-35.46,35.46,0,.32-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m522.69,299.85c-.05,0-.11,0-.16-.02-.31-.09-.48-.41-.39-.71,3.84-13.34,16.22-22.66,30.12-22.66.32,0,.57.26.57.57s-.26.57-.57.57c-13.39,0-25.32,8.98-29.02,21.83-.07.25-.3.42-.55.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m552.26,339.14c-.32,0-.57-.26-.57-.57s.26-.57.57-.57c13.27,0,25.17-8.87,28.94-21.58.09-.3.41-.48.71-.39.3.09.48.41.39.71-3.92,13.19-16.27,22.4-30.05,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m557.96,333.24c-.26,0-.5-.18-.56-.45-.07-.31.12-.62.43-.69,8.31-1.9,15.21-8.09,17.99-16.16.1-.3.43-.46.73-.36.3.1.46.43.36.73-2.92,8.44-10.13,14.92-18.82,16.91-.04.01-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m552.26,344.41c-2.4,0-4.8-.23-7.14-.7-.31-.06-.51-.36-.45-.68.06-.31.36-.51.68-.45,2.26.45,4.59.67,6.91.67,16.08,0,30.18-10.85,34.28-26.38.08-.31.4-.49.7-.41.31.08.49.4.41.7-4.24,16.03-18.79,27.23-35.39,27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.3,314.71c-3.81,0-6.91-3.1-6.91-6.91s3.1-6.91,6.91-6.91,6.91,3.1,6.91,6.91-3.1,6.91-6.91,6.91Zm0-12.67c-3.18,0-5.76,2.58-5.76,5.76s2.58,5.76,5.76,5.76,5.76-2.58,5.76-5.76-2.58-5.76-5.76-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m184.7,320.19c-6.12,0-11.1-4.98-11.1-11.1s4.98-11.1,11.1-11.1,11.1,4.98,11.1,11.1-4.98,11.1-11.1,11.1Zm0-21.06c-5.49,0-9.96,4.47-9.96,9.96s4.47,9.96,9.96,9.96,9.96-4.47,9.96-9.96-4.47-9.96-9.96-9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.3,301.96c-.26,0-.48-.21-.49-.47-.01-.27.2-.5.47-.51l65.4-2.91c.27-.03.5.2.52.47.01.27-.2.5-.47.51l-65.4,2.91s-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,320.19H184.7l-65.45-5.48c-.32-.03-.55-.3-.52-.62.03-.32.3-.56.62-.52l65.4,5.48h289.2c.32,0,.57.25.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.95,309.28c-.27,0-.54-.07-.78-.22-.69-.43-.91-1.34-.48-2.04l34.52-55.61c.27-.44.75-.7,1.26-.7h355.27c.82,0,1.48.66,1.48,1.48s-.66,1.48-1.48,1.48H154.29l-34.09,54.91c-.28.45-.76.7-1.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m184.7,309.28c-.27,0-.54-.07-.78-.23-.69-.43-.9-1.35-.47-2.04l49.25-78.72c.43-.69,1.35-.9,2.04-.47.69.43.9,1.35.47,2.04l-49.25,78.72c-.28.45-.76.7-1.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,309.28H118.95c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48h355c.82,0,1.48.66,1.48,1.48s-.66,1.48-1.48,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m184.71,309.28c-.52,0-1.03-.27-1.3-.76l-41.54-74.83c-.4-.72-.14-1.62.58-2.01.72-.4,1.62-.14,2.01.58l41.54,74.83c.4.72.14,1.62-.58,2.01-.23.13-.47.19-.72.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m552.26,314.71c-3.81,0-6.91-3.1-6.91-6.91s3.1-6.91,6.91-6.91,6.91,3.1,6.91,6.91-3.1,6.91-6.91,6.91Zm0-12.67c-3.18,0-5.76,2.58-5.76,5.76s2.58,5.76,5.76,5.76,5.76-2.58,5.76-5.76-2.58-5.76-5.76-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m132.47,229.76l21.39,1.48c.95.07,1.67.89,1.61,1.85-.06.87-.76,1.55-1.61,1.61l-21.39,1.48c-1.77.12-3.31-1.21-3.43-2.99-.12-1.77,1.21-3.31,2.99-3.43.14,0,.3,0,.44,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.95,308.37c-.24,0-.46-.15-.54-.39l-17.34-51.17c-.1-.3.06-.63.36-.73.3-.1.63.06.73.36l17.34,51.17c.1.3-.06.63-.36.73-.06.02-.12.03-.18.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.95,308.37c-.06,0-.12,0-.18-.03-.3-.1-.46-.43-.36-.73l17.33-51.17c.1-.3.43-.46.73-.36.3.1.46.43.36.73l-17.33,51.17c-.08.24-.3.39-.54.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.95,308.37c-.32,0-.57-.26-.57-.57v-51.17c0-.32.26-.57.57-.57s.57.26.57.57v51.17c0,.32-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m138.95,257.21h-54.05c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h53.48v-3.33c0-.32.26-.57.57-.57s.57.26.57.57v3.91c0,.32-.26.57-.57.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m139.23,238.75c-3.03,0-5.74-2.1-6.44-5.1l.55-.18.56-.13v.05c.63,2.65,3.14,4.44,5.85,4.19l5.91-.6c.31-.03.6.2.63.51.03.32-.2.6-.51.63l-5.91.6c-.21.02-.42.03-.62.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m331.9,320.19c-6.12,0-11.1-4.98-11.1-11.1s4.98-11.1,11.1-11.1,11.1,4.98,11.1,11.1-4.98,11.1-11.1,11.1Zm0-21.06c-5.49,0-9.96,4.47-9.96,9.96s4.47,9.96,9.96,9.96,9.96-4.47,9.96-9.96-4.47-9.96-9.96-9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m331.9,309.28c-.27,0-.54-.07-.78-.23-.69-.43-.9-1.35-.47-2.04l49.25-78.72c.43-.69,1.35-.9,2.04-.47.69.43.9,1.35.47,2.04l-49.25,78.72c-.28.45-.76.7-1.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m331.9,309.28c-.52,0-1.03-.27-1.3-.76l-41.54-74.83c-.4-.72-.14-1.62.58-2.01.71-.4,1.62-.14,2.01.58l41.54,74.83c.4.72.14,1.62-.58,2.01-.23.13-.47.19-.72.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m279.67,229.76l21.39,1.48c.95.07,1.67.89,1.61,1.85-.06.87-.76,1.55-1.61,1.61l-21.39,1.48c-1.77.12-3.31-1.21-3.43-2.99-.12-1.77,1.21-3.31,2.99-3.43.14,0,.3,0,.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m286.42,238.75c-3.03,0-5.74-2.1-6.44-5.1-.07-.31.11-.64.42-.71.31-.08.61.09.68.4v.05c.63,2.65,3.14,4.45,5.85,4.19l5.91-.6c.31-.03.6.2.63.51.03.32-.2.6-.51.63l-5.91.6c-.21.02-.42.03-.62.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,320.19c-6.12,0-11.1-4.98-11.1-11.1s4.98-11.1,11.1-11.1,11.1,4.98,11.1,11.1-4.98,11.1-11.1,11.1Zm0-21.06c-5.49,0-9.96,4.47-9.96,9.96s4.47,9.96,9.96,9.96,9.96-4.47,9.96-9.96-4.47-9.96-9.96-9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,309.28c-.27,0-.54-.07-.78-.23-.69-.43-.9-1.35-.47-2.04l49.25-78.72c.43-.69,1.35-.9,2.04-.47.69.43.9,1.35.47,2.04l-49.25,78.72c-.28.45-.76.7-1.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,309.28c-.52,0-1.03-.27-1.3-.76l-41.54-74.83c-.4-.72-.14-1.62.58-2.01.71-.4,1.62-.14,2.01.58l41.54,74.83c.4.72.14,1.62-.58,2.01-.23.13-.47.19-.72.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m552.26,309.28c-.19,0-.37-.04-.56-.11l-.16-.06c-10.27-4.17-18.94-11.78-24.4-21.42l-19.69-34.77c-.4-.71-.15-1.62.56-2.02.71-.4,1.62-.15,2.02.56l19.69,34.77c5.14,9.07,13.28,16.22,22.94,20.14l.16.06c.76.31,1.12,1.17.81,1.93-.23.58-.79.92-1.37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m421.72,229.76l21.39,1.48c.95.07,1.67.89,1.61,1.85-.06.87-.76,1.55-1.61,1.61l-21.39,1.48c-1.77.12-3.31-1.21-3.43-2.99-.12-1.77,1.21-3.31,2.99-3.43.14,0,.3,0,.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m428.47,238.75c-3.03,0-5.74-2.1-6.44-5.1l.55-.18.56-.13v.05c.63,2.64,3.14,4.44,5.85,4.19l5.91-.6c.33-.02.6.2.63.51.03.32-.2.6-.51.63l-5.91.6c-.21.02-.42.03-.62.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m473.95,299.17H183.78c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h290.17c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m539.7,230.63h-16.51c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48h16.51c3.34,0,6.06-2.72,6.06-6.05s-2.72-6.06-6.06-6.06c-1.43,0-2.81.51-3.9,1.43-.62.53-1.56.45-2.09-.18-.53-.62-.45-1.56.18-2.09,1.62-1.37,3.69-2.12,5.81-2.12,4.97,0,9.02,4.04,9.02,9.02s-4.05,9.02-9.02,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m397.65,230.63h-16.51c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48h16.51c3.34,0,6.06-2.72,6.06-6.05s-2.72-6.06-6.06-6.06c-1.43,0-2.81.51-3.9,1.43-.62.53-1.56.45-2.09-.18-.53-.62-.45-1.56.18-2.09,1.62-1.37,3.69-2.12,5.81-2.12,4.97,0,9.02,4.04,9.02,9.02s-4.04,9.02-9.02,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m250.46,230.63h-16.51c-.82,0-1.48-.66-1.48-1.48s.66-1.48,1.48-1.48h16.51c3.34,0,6.05-2.72,6.05-6.05s-2.72-6.06-6.05-6.06c-1.43,0-2.81.51-3.9,1.43-.62.53-1.56.45-2.09-.18-.53-.63-.45-1.56.18-2.09,1.62-1.37,3.69-2.12,5.81-2.12,4.97,0,9.02,4.04,9.02,9.02s-4.04,9.02-9.02,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m303,257.21h-41.95c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h41.95c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m113.57,253.3h-39.87c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h39.87c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m465.59,324.53h-26.84c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h26.84c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m248.15,229.9c.02-.35.22-.68.56-.85.51-.26,1.13-.06,1.39.45l1.04,2.02c.26.51.06,1.13-.45,1.39-.51.26-1.13.06-1.39-.45l-1.04-2.02c-.09-.17-.12-.35-.11-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m245.76,233.9l-1.98-4.09c-.23-.52,0-1.13.53-1.36.49-.22,1.07-.01,1.32.45l2.44,3.86c.34.63.11,1.41-.52,1.75-.63.34-1.41.11-1.75-.52-.02-.03-.03-.06-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m242.2,232.88l-.54-3.76c-.11-.56.25-1.1.81-1.21.53-.1,1.04.22,1.19.72l1.04,3.64c.2.68-.19,1.4-.87,1.6-.68.2-1.4-.19-1.6-.87-.01-.04-.02-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m242.03,229.07l-.07,2.51c.08.71-.43,1.35-1.14,1.42-.71.08-1.35-.43-1.42-1.14,0-.05,0-.11,0-.16l.59-2.54c0-.57.48-1.03,1.05-1.02.53,0,.96.41,1.01.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ground"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m513.63,355.27H97.46c-21.28,0-36.8-8.13-48.14-14.07-8.03-4.21-13.84-7.25-17.25-4.71-.92.69-1.32,1.41-1.2,2.21.55,3.79,11.46,8.59,15.62,10.12.29.11.44.43.35.72-.1.29-.41.46-.71.37-11.42-3.47-41.76-10.96-45.03-4.04-.14.29-.48.41-.76.27-.29-.14-.41-.48-.27-.76,3.23-6.83,26.18-1.95,38.57,1.25-4.13-2.11-8.49-4.96-8.89-7.77-.18-1.24.38-2.35,1.65-3.3,3.99-2.97,10.07.21,18.47,4.62,11.23,5.88,26.6,13.94,47.6,13.94h416.17c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m71.34,332.52c-.12,0-.24-.04-.35-.12-23.32-17.86-44.4-15.1-44.61-15.07-.31.04-.61-.17-.65-.49-.04-.31.17-.61.49-.65.22-.03,21.78-2.86,45.47,15.29.25.19.3.55.11.81-.11.15-.28.22-.46.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m513.63,355.27s-.08,0-.12-.01c-9.03-1.87-14.65-4.39-15.42-6.91-.21-.7-.04-1.38.48-1.92,1.58-1.62,6.02-1.78,11.04-.4,2.73.75,5.46,1.76,8.36,2.82,6.71,2.47,14.32,5.26,23.5,5.26h92.71c.32,0,.57.26.57.57s-.26.57-.57.57h-92.71c-9.39,0-17.1-2.83-23.9-5.33-2.87-1.06-5.58-2.05-8.27-2.8-5.03-1.39-8.86-.99-9.91.09-.23.24-.29.48-.2.78.47,1.53,4.56,4.05,14.56,6.12.31.06.51.37.45.68-.06.27-.3.46-.56.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m84.4,348.58c0,.82-.66,1.48-1.48,1.48s-1.48-.66-1.48-1.48.66-1.48,1.48-1.48,1.48.66,1.48,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m64.37,333.91c0,1.28-1.03,2.31-2.31,2.31s-2.31-1.03-2.31-2.31,1.03-2.31,2.31-2.31,2.31,1.03,2.31,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m61.35,308.21c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07.48-1.07,1.07-1.07,1.07.48,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m504.34,334.97c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07.48-1.07,1.07-1.07,1.07.48,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m491.97,348.3c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07.48-1.07,1.07-1.07,1.07.48,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m444.81,336.04c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07.48-1.07,1.07-1.07,1.07.48,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m484.48,341.2c0,1.2-.97,2.16-2.16,2.16s-2.16-.97-2.16-2.16.97-2.16,2.16-2.16,2.16.97,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.73,325.47c0,.59-.48,1.07-1.07,1.07s-1.07-.48-1.07-1.07.48-1.07,1.07-1.07,1.07.48,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m463.42,362.09h-123.53c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h123.53c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m369.19,369.55h-60.58c-.32,0-.57-.26-.57-.57s.26-.57.57-.57h60.58c.32,0,.57.26.57.57s-.26.57-.57.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m490.47,355.27c-2.03,0-11.94-1.77-15.47-5.51-.22-.23-.21-.59.02-.81.23-.22.59-.21.81.02,3.24,3.43,12.77,5.15,14.64,5.15.32,0,.57.26.57.57s-.26.57-.57.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m207.13,148.82c.43-.05,2.15-.12,3.8,2.07,1.65,2.19-6.03,3.37-6.03,3.37l2.22-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m209.33,331.69c-.14,0-.28-.05-.39-.15l-23.83-22.03c-.23-.22-.25-.58-.03-.81.22-.23.58-.25.81-.03l23.83,22.03c.23.22.25.58.03.81-.11.12-.27.18-.42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m204.25,311.36c-.56-.72-1.68.26-1.88.44-.84.77-1.72,2.28-1.75,2.32l.62,3.38s1.27-1.84,1.26-1.86c-.02-.02,1.76-4.28,1.76-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m194.47,317.46s-.29-.74.56-1.18c.46-.24,2.39-.75,2.39-.75l.56,2.37-3.51-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m186.98,182.24c2.23,1.63,3.56,16.79,13.6,21.13.29-8.23,13.4-21.88,14.81-27.21,1.41-5.33.62-17.79-5.54-26.22-1.99.31-4.63,1.8-4.63,1.8,1.43-.56-5.55,25.76-18.25,30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m217.18,167.26c-1.08-5.07-2.58-8.73-1.19-12.6,1.82-5.04,3.02-7.86,3.02-7.86l-6.14-5.54s-6.63,14.2-9.15,19.53c-2.53,5.34,10.87,11.28,10.87,11.28l2.6-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m215.88,143.96c-1.34-.21-3.94-.61-4.57.75.97,4.05,2.38,6.04,4.97,9.19h0c.95-2.61,1.71-4.56,2.19-5.75l-2.58-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m224,126.09c6.12,3.87,1.8,11.67,1.81,13.64,0,3.14,2.86,3.88,2.86,3.88.08,1.82-1.31,1.78-1.53,2.36-.22.58-.81,3.35-1.19,4.33-.18.45-.82,2.48-2.14,2.36-1.56-.14-9.92-3.35-14.52-9.78-7.01-9.79-.46-26.38,14.72-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m212.16,122.49s-2.45-2.75-5.89-1.71c-3.65,1.1-3.73,3.8-3.98,5.17-.22,1.22,14.09,6.37,17.65,3.23,0,0,2.52,1.69,3.32,5.55,0,0,8.85-.76,9.47-7.19-4.64,1.07-5.79-12.8-20.57-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m228.66,143.61s-2.64-1.09-2.85-3.94c-.26,1.37-.15,4.24,1.32,6.3.22-.58,1.62-.53,1.53-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m203.98,126.2c-1.26-1.26-4.81-10.01-13.64-8.15-9.19,1.94-10.81,17.56-26.22,23.88-7.21,2.95-42.39,6.89-30.48,21.48-5.41-15.3,38.75-3.78,58.06-21.89,6.99-6.56,10.13-13.89,12.28-15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m121.92,160.21c-.25,0-.48-.17-.55-.42-1.45-5.25-.69-9.99,2.15-13.35,3.21-3.79,8.72-5.49,15.5-4.79.75.08,1.5.16,2.26.25,8.73.97,18.63,2.06,31.76-3.49.29-.12.63.01.75.31s-.01.63-.31.75c-13.41,5.67-23.46,4.56-32.34,3.57-.76-.08-1.51-.17-2.25-.25-6.39-.67-11.54.89-14.5,4.39-2.59,3.05-3.27,7.42-1.92,12.3.08.31-.09.62-.4.71-.05.01-.1.02-.15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m140.67,162.98c-.06,0-.12,0-.18-.03-2.14-.71-3.33-2.23-3.27-4.16.09-2.42,2.37-5.44,6.56-6.51,4.7-1.21,10.67-1.14,16.98-1.07,9.01.1,18.32.2,25.6-3.2,9.97-4.66,11.71-14.88,12.55-19.79l.05-.27c.05-.31.35-.52.66-.47.31.05.52.35.47.66l-.05.27c-.8,4.7-2.69,15.72-13.2,20.63-7.51,3.51-16.96,3.41-26.1,3.31-6.24-.07-12.13-.13-16.68,1.03-3.65.93-5.63,3.44-5.7,5.44-.05,1.4.83,2.48,2.48,3.03.3.1.46.43.36.73-.08.24-.3.39-.54.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m185.27,144.13c-.31,0-.57-.25-.57-.56,0-.32.25-.58.56-.59,12.64-.26,15.08-8.98,15.88-11.84.05-.19.1-.35.14-.48.09-.3.41-.48.72-.38.3.09.47.41.38.72-.04.13-.08.28-.13.45-.86,3.07-3.47,12.4-16.96,12.68h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m202.54,126.09c-1.65,1.58-5.69,12.87,7.62,20.96,4.71-11.06,8.29-7.9,9.07-13.21l2.33-6.32-19.02-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m215.23,139.73c-.44,1.72-2.19,2.76-3.91,2.32-1.72-.44-2.76-2.19-2.32-3.91.44-1.72,2.19-2.76,3.91-2.32,1.72.44,2.76,2.19,2.32,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m213.64,139.33c-.21.84-1.07,1.35-1.91,1.13-.84-.21-1.35-1.07-1.13-1.91.21-.84,1.07-1.35,1.91-1.13.84.21,1.35,1.07,1.13,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m230.48,125.87c-1.98,0-4.36-1.17-6.93-3.47-.24-.21-.26-.57-.04-.81.21-.24.57-.26.81-.04,1.74,1.55,6.05,4.87,8.56,2.11.21-.23.58-.25.81-.04.23.21.25.58.04.81-.88.97-1.98,1.44-3.24,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m180.68,171.31c-.8-.02-.23,7.74,1,10.96,1.23,3.22,4.86,1.49,4.86,1.49l.44-10.22-6.3-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m188.85,304.04c2.47,4.64,5.48,9.59,9.14,14.88l4.53-1.01s-2.25-6.9-4.84-16.66l-8.82,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m179.11,179.37c-.42-.28-1.29,1.84-.94,5.75,0,0,3.8-1.1,3.86-1.15.06-.05-2.93-4.61-2.93-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m181.2,184.22c-3.69.77-22.5,2.13-25.7,17.04-4.4,20.54,22.01,43.87,22.2,53.42.16,8.08-2.43,23.91,11.14,49.36l8.82-2.79c-3.45-12.98-7.53-31.01-7.76-44.62-.53-30.45-6.75-40.73-6.27-48,.38-5.74,4.91-11.22,8.35-12.55l-10.79-11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m189.77,302.04c-.24,0-.46-.15-.54-.39-8.94-26.07-8-34.36-7.16-41.68.29-2.59.57-5.03.39-8.1-.3-5.02-3.56-10.73-7.01-16.77-5.56-9.74-11.86-20.78-9.14-33.48,1.96-9.13,10.23-12.81,16.28-14.78.3-.1.63.07.72.37.1.3-.07.63-.37.72-5.78,1.88-13.68,5.37-15.51,13.93-2.63,12.27,3.56,23.11,9.01,32.67,3.52,6.16,6.84,11.98,7.16,17.27.19,3.17-.09,5.66-.39,8.3-.82,7.2-1.75,15.36,7.11,41.18.1.3-.06.63-.36.73-.06.02-.12.03-.19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m180.06,252.19c-.19-9.55-25.05-29.35-18.86-50.93,3.19-11.1,14.06-13.16,21.67-13.49l-1.67-3.54c-3.69.77-22.5,2.13-25.7,17.04-4.4,20.54,22.01,43.87,22.2,53.42.16,8.08-2.43,23.91,11.14,49.36l.92-.29c-12.65-24.54-9.54-43.64-9.7-51.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m184.7,204.23c1.4-3.57,5.22-7.2,6.88-7.98l-1.47-2.24-8.92-9.8c-.29.06-.68.13-1.14.2h0c.24,4.73,1.97,15.83,4.64,19.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m191.1,199.3c4.95-6.76,18.34-14.5,24.96-20.38,4.12-3.66.19-14.02-.6-20.09-.04.02-2.58,9.21-6.78-8.61-12.82,2.85-9.31,13.24-13.92,20.97-3.23,5.43-9.52,7.44-15.7,8.15,2.43,8.61,6.51,17.47,12.03,19.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m198.91,318.59c-3.65-5.28-6.66-10.22-9.12-14.85l-.94.3c2.47,4.64,5.48,9.59,9.14,14.88l.92-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m180.68,171.31c4.21,2.22,2.27,16.87,9.93,21.3,5.13-2.25,16.65-13.67,18.29-18.93,2.4-7.67-3.71-19.84-1.77-24.85-2.84.31-5.31,4.45-5.31,4.45-1.26,1.71-5.89,14.98-21.15,18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m201.56,333.01c-.27,0-.52-.2-.57-.48-.05-.31.16-.61.47-.66l15.53-2.65c.31-.05.61.16.66.47.05.31-.16.61-.47.66l-15.53,2.65s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m224.67,322.49s-1.52-.38-2.85-.04c-1.02.26-2.04.46-3.05.65-2.72.5-8.42-1.35-10.53-2.56-1.88-1.08-5.74-4.14-5.74-4.14,0,0,.19-.54-.71-.27s-2.41,1.04-3.34,1.19c-1.32.21-4,.07-4,.07,0,0,1.58,3.87,1.59,4.83.02.96-.43,3.86-.55,4.92-.19,1.59.4,2.91.4,2.91l1.21,1.18,27.59-6.94-.02-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m220.21,322.77c.53-.13,1.06-.3,1.59-.44,1.33-.34,2.88.16,2.88.16l.02,1.81-3.45.05-1.03-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m224.67,322.49s-3.46,2.07-6.1,3.02c-1.44.52-20.6,4.48-20.6,4.48l-2.09.08s-.17,1.29.14,1.89c.31.6.4,1.02,1.04,1.07.64.05,5.91-1.56,7.42-1.91,1.83-.43,6.56-.46,13-2.25,2.66-.74,8.47-2.36,8.74-3.89.26-1.53-.38-2.47-1.56-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m220.09,324.15c-4.3.49-8.55.87-11.7-.42-3.36-1.38-5.14-3.6-7.25-7.37-.16-.74,2.32-4.91,3.09-5.02-.92,2.22-.8,4.52-.05,5.74,1.06,1.73,3.04,2.81,5.24,3.83,3.45,1.6,8.1,1.98,9.13,1.98.43,0,1.65-.13,1.65-.13.86.17,1.03,1.58,1.03,1.58-.05-.05-.29-.3-1.15-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m221.22,324.33s.01.01.01.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m206.96,324.35s-.04,0-.06,0c-.31-.03-.54-.31-.51-.63.01-.1.26-2.44,2.08-3.59.27-.17.62-.09.79.18.17.27.09.62-.18.79-1.34.85-1.55,2.72-1.56,2.74-.03.29-.28.51-.57.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m210.62,325.5c-.3,0-.55-.23-.57-.54,0-.1-.13-2.35,1.33-3.63.24-.21.6-.19.81.05s.19.6-.05.81c-1.02.91-.94,2.68-.94,2.7.02.32-.22.59-.54.61-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.02,325.61c-.26,0-.5-.18-.56-.45-.02-.07-.38-1.81.81-3.09.22-.23.58-.25.81-.03.23.22.24.58.03.81-.77.83-.53,2.05-.53,2.06.06.31-.13.61-.44.68-.04,0-.08.01-.12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m217.63,325.47c-.24,0-.47-.15-.55-.4-.05-.15-.46-1.52.25-2.54.18-.26.54-.32.8-.14.26.18.32.54.14.8-.33.47-.18,1.28-.1,1.52.1.3-.07.63-.37.72-.06.02-.12.03-.18.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m195.88,330.06l2.09-.08s14.33-2.96,19.14-4.1l-.1.02.57,2.92s-.05.01-.07.02c-6.44,1.79-11.17,1.82-13,2.25-1.52.35-6.79,1.96-7.42,1.91-.64-.05-.73-.47-1.04-1.07-.31-.6-.14-1.89-.14-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m204.8,320.05c-.19,0-.38-.1-.49-.27-.31-.5-3.03-4.99-2.22-7.19.21-.56.62-.95,1.2-1.14.77-.25,1.49-.08,2.03.47,1.36,1.41,1.21,4.95.28,7.55-.06.16-.18.28-.33.34-.04.06-.1.11-.17.16-.09.06-.2.09-.3.09Zm-.82-7.57c-.1,0-.21.02-.33.06-.24.08-.38.21-.47.44-.39,1.07.63,3.52,1.6,5.29.68-2.46.44-4.82-.28-5.56-.11-.11-.26-.23-.52-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.7,321.83c-.05,0-.1,0-.15-.02-.3-.08-.48-.4-.4-.7.03-.1.66-2.34,2.63-2.75.31-.06.61.14.68.45.06.31-.14.61-.45.68-1.28.26-1.75,1.91-1.76,1.93-.07.25-.3.42-.55.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m204.52,319.73c-.08.05-.16.09-.26.1-3.2.44-4.8-.55-5.23-1.63-.28-.69-.07-1.44.51-1.86.39-.28.91-.38,1.46-.29.82.13,2.12.74,3.65,2.88.12.16.14.38.06.56-.04.1-.11.18-.19.24Zm-4.31-2.46c-.15.11-.19.3-.11.5.18.45,1,1.08,2.98,1.01-1.1-1.28-1.93-1.55-2.27-1.6-.25-.04-.47,0-.61.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m198.18,302.4c-2.5,1.13-6.95,4.02-6.95,4.02l-.93-1.53,7.89-2.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "188.33 301.62 197.1 299.08 197.51 300.63 189.51 303.24 188.33 301.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m188.84,305.32c-.54,0-1.05-.35-1.22-.9-.21-.68.16-1.4.84-1.61l8.82-2.79c.68-.21,1.4.16,1.61.84.21.68-.16,1.4-.84,1.61l-8.82,2.79c-.13.04-.26.06-.39.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m178.55,196.77c-3.38,0-5.14-1.79-6.62-3.73-.19-.25-.14-.61.11-.81.25-.19.61-.15.81.11,1.54,2.02,3.66,4.77,10.6,2.25.3-.11.63.05.74.34.11.3-.05.63-.34.74-2.12.77-3.85,1.09-5.29,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m94.31,190.33s-.04-.14-.1-.42c-.07-.29-.19-.71-.33-1.26-.28-1.11-.72-2.75-1.12-4.88-.38-2.13-.82-4.74-.73-7.84.07-1.55.25-3.25,1.04-4.98.41-.86,1-1.72,1.87-2.37.91-.7,2.12-.98,3.2-.93,1.09.04,2.08.3,3.04.59.96.3,1.89.65,2.82,1.03,1.85.74,3.71,1.53,5.65,2.23,3.87,1.41,8.05,2.52,12.49,2.9,4.42.41,9.05.16,13.66-.72,4.63-.87,9.28-2.19,13.83-3.81,4.55-1.61,9-3.52,13.33-5.54,4.33-2.02,8.52-4.18,12.58-6.29,4.08-2.08,8.02-4.14,11.9-5.87,1.94-.86,3.88-1.65,5.83-2.25,1.95-.59,3.93-1.05,5.95-1.02,1.92.03,3.85.34,5.52,1.14,1.68.77,3.04,1.99,3.96,3.32.93,1.33,1.48,2.74,1.84,4.05.35,1.31.51,2.54.59,3.64.15,2.21-.03,3.92-.17,5.08-.07.58-.15,1.02-.2,1.32-.06.31-.09.46-.09.46-.06.31-.36.51-.67.45-.3-.06-.5-.34-.46-.64v-.03s.03-.14.07-.42c.04-.28.09-.71.13-1.27.08-1.11.14-2.77-.07-4.83-.11-1.03-.31-2.15-.67-3.32-.36-1.16-.9-2.37-1.72-3.45-.82-1.08-1.94-2-3.32-2.58-1.38-.59-3-.85-4.73-.83-1.66,0-3.45.43-5.25,1.02-1.81.6-3.66,1.39-5.53,2.27-3.75,1.76-7.63,3.88-11.67,6.04-4.04,2.15-8.25,4.37-12.62,6.47-4.36,2.1-8.9,4.06-13.55,5.73-4.66,1.67-9.43,3.05-14.25,3.96-4.84.89-9.76,1.16-14.46.67-4.7-.49-9.14-1.71-13.11-3.3-1.99-.78-3.87-1.64-5.66-2.41-1.78-.76-3.53-1.53-5.05-1.65-.75-.06-1.38.09-1.9.44-.55.37-1,.95-1.33,1.58-.66,1.29-.91,2.8-1.02,4.21-.19,2.85.12,5.42.42,7.5.32,2.09.64,3.73.87,4.84.12.56.21.99.27,1.28.06.3.09.45.09.45.06.31-.14.61-.45.67-.3.06-.59-.13-.67-.42h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m138.43,214.55l-17.42,15.36c-1.89,1.66-4.83,1.41-6.57-.56l-27.2-30.84c-1.74-1.97-1.62-4.92.27-6.59l17.42-15.36c1.89-1.66,4.83-1.41,6.57.56l27.2,30.84c1.74,1.97,1.62,4.92-.27,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m137.25,213.17l-13.86,12.22c-1.5,1.32-4.13.8-5.87-1.18l-27.2-30.84c-1.74-1.97-1.93-4.65-.43-5.97l13.86-12.22c.82-.72,2.62-2.52,2.62-2.52,0,0,2.46,2.8,3.25,3.7l27.2,30.84c1.78,1.8,3.93,2.77,3.93,2.77,0,0-2.74,2.53-3.5,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m123.64,206.24c-12.24,1.44-30.94-.25-44.75-16.62l14.58-17.1c6.43,7.17,20.09,20.6,30.67,27.36,3.78,2.42,3.9,5.84-.51,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.85,212.8l-11.71,14.22c-1.89,1.66-4.83,1.41-6.57-.56l-27.2-30.84c-1.74-1.97-1.62-4.92.27-6.59l11.9-15.63c.86-1.01,3.02-3.88,3.02-3.88-.1-.08,2.27,3.11,3.55,4.44l27.2,30.84c2.38,2.36,3.87,2.84,3.87,2.84,0,0-3.15,4.11-4.33,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m132.9,214.28l-11.9,15.63c-1.89,1.66-4.83,1.41-6.57-.56l-27.2-30.84c-1.74-1.97-1.62-4.92.27-6.59l11.9-15.63c1.87-2.15,4.83-1.41,6.57.56l27.2,30.84c1.74,1.97,1.37,4.64-.27,6.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m176.8,166.82c-17.16,12.48-36.9,26.24-36.9,26.24l1.76,3.47s33.78-16.64,40.89-20.5c4.75-2.58,28.84-11.75,24.45-21.77-4.9-11.2-24.17,8.17-30.21,12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m126.9,217.59s.23.18.66.51c.45.35,1.01.76,1.81,1.28.79.53,1.8,1.09,2.99,1.6,1.19.5,2.58.94,4.12,1.06,1.54.13,3.22-.05,4.93-.65,1.71-.57,3.42-1.57,5.08-2.79,1.66-1.23,3.26-2.7,4.81-4.29,1.56-1.59,3.07-3.29,4.56-5.03,2.98-3.48,5.9-7.07,8.82-10.31,2.91-3.25,5.84-6.13,8.6-8.35,2.75-2.23,5.31-3.78,7.19-4.7.46-.24.89-.44,1.26-.6.37-.17.69-.31.95-.41.52-.21.8-.32.8-.32.59-.24,1.26.05,1.49.64.23.59-.05,1.25-.63,1.49l-.05.02s-.26.1-.74.3c-.24.09-.53.22-.88.38-.34.15-.74.34-1.17.56-1.74.87-4.12,2.34-6.73,4.48-2.61,2.14-5.43,4.94-8.26,8.15-2.84,3.2-5.71,6.79-8.7,10.34-1.5,1.77-3.03,3.53-4.64,5.19-1.61,1.66-3.29,3.24-5.09,4.6-1.81,1.35-3.74,2.51-5.78,3.22-2.03.73-4.15.99-6.05.83-1.91-.14-3.59-.66-4.99-1.23-1.4-.59-2.54-1.22-3.43-1.8-.89-.56-1.62-1.09-2.02-1.4-.43-.33-.66-.5-.66-.5-.63-.48-.76-1.38-.28-2.01s1.38-.76,2.01-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.75,195.38c-1.17.28-5.54,5.2-8.51,8.67l-1.28-1.46c.42-.83.62-1.58.18-1.93-.88-.7-8.09-.32-10.83-1.88-.63-.36-.92-1-.62-1.33,4.1.66,9.31.78,9.31.78l11.76-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m132.3,196.18l-10.7-1.18c-.11.18-.38.81.63,1.24,1.01.43,9.76,1.98,9.76,1.98l.31-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m123.77,193.05l9.08,1.44-.55,1.69s-7.28-1.18-8.31-1.86c-.71-.46-.44-1.19-.22-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m126.03,192.48s3.86-1.52,4.32-1.46c.46.06,2.82,2.17,4.26,2.34s5.68-.57,6.74-1.31c1.06-.74-.57,2.13-.57,2.13l-7.93.32-2.91-1.84s-2.72.64-3.11.6c-.74-.08-.93-.5-.79-.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "132.85 194.49 132.3 196.18 132 198.23 143.28 195.49 141.49 192.76 132.85 194.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m206.47,160.35l-13.84,5.32c-2.93,2.43-6.74,4.54-11.67,5.57-.02.06-.05.13-.07.2,1.91,1.26,2.49,5.25,3.43,9.53,0,0,0,0,0,0,8.81-3.16,21.05-16.46,22.16-20.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m207,154.26c-5.17-11.08-24.17,8.17-30.21,12.56-3.82,2.78-7.78,5.63-11.61,8.37h0s4.01,7.66,4.01,7.66h0c5.89-2.95,43.44-16.52,37.81-28.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "164.45 175.72 166.22 184.35 168.72 183.09 164.45 175.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.2,184.14c-.46,0-.91-.25-1.14-.69l-4.01-7.66c-.33-.63-.09-1.4.54-1.73.63-.33,1.4-.09,1.73.54l4.01,7.66c.33.63.09,1.4-.54,1.73-.19.1-.39.15-.59.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m206.59,154.22c-2.98,0-6.42-.93-9.62-3.42-.25-.19-.29-.56-.1-.81.19-.25.56-.29.81-.1,5.65,4.4,12.02,3.57,14.73,1.57,3.91-2.88,4.67-8.09,5.4-13.12.5-3.4.96-6.6,2.41-8.81.17-.26.53-.34.8-.17.27.17.34.53.17.8-1.31,2-1.76,5.08-2.24,8.35-.73,5.03-1.56,10.72-5.86,13.88-1.44,1.06-3.78,1.83-6.5,1.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m80.79,172.62c-8.66,1.79-37.53,1.71-52.97-23.01l17.55-13.21c7.26,10.87,26.01,34.36,35.43,36.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m46.66,167.05s12.38-1.85,20.21-7.75c4.68,6.52,13.93,13.32,13.93,13.32,0,0-16.26,3.99-34.14-5.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m388.06,224.06l4.06-.36.78.13h0s.13.09.21.13l.26.14c.18.09.37.17.56.24.38.15.77.25,1.15.32.77.13,1.53.07,2.2-.3l.04-.02c.38-.21.87-.07,1.08.31.18.32.11.71-.14.96-.42.41-.94.74-1.49.96-.55.22-1.13.35-1.71.41-.57.05-1.14.04-1.7-.02-.28-.03-.56-.07-.83-.13l-.42-.09c-.15-.04-.26-.06-.46-.13h0s.78.13.78.13l-4.05.48c-.87.1-1.65-.52-1.76-1.38-.1-.87.52-1.65,1.38-1.76.01,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m389.37,225.81l-33.09-68.43s-16.02-4.95-13.94,9.24c2.99,20.48,22.45,45.19,43.05,64.84l3.98-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m340.74,167.77c1.27,8.08,4.71,18.22,10.43,26.85,12.09-3.78,19.46-9.95,19.46-9.95,0,0-11.66-31.54-21.59-32.04,0,0-10.72-.27-8.3,15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m350.03,149.82c.6-.1,3.23-.1,5.36,2.97,2.13,3.06-6.91,2.11-6.91,2.11l1.56-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m370.99,143.18s1.87,6.33,1.08,6.84c-.5.32-2.94-.15-2.94-.15l1.86-6.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.21 153.96 354.55 147.14 362.19 152.29 352.51 164.64 348.88 162.04 346.21 153.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m352.54,148.33c-1.03,4.5.98,10.11,2.85,12.63l.98-1.26,3.46-4.41-7.29-6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m367.14,157.01c1.7-.48,5.58-16,3.26-21.41-7.83-18.21-26.62,4.98-16.01,15.78,6.53,6.65,11.85,5.89,12.76,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m346.21,154.3c-16.2-10.07-30.78,3.78-33.07,4.66-1.5.58-25.47,0-29.35,9.76-2.97,7.47,5.23,13.73,5.23,13.73l40.28-11.11,16.91-17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m355.27,161.22s-6.5-7.52-5.24-11.4c-3.45.65-15.6,4.19-19.74,5.3l24.98,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m325.56,282.93c.67,1.15,16.93-1.23,17.05-2.89.12-1.65-7.39-2.04-7.39-2.04l-9.67,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m355.72,331.69c-.14,0-.28-.05-.39-.15l-23.83-22.03c-.23-.22-.25-.58-.03-.81.22-.23.58-.25.81-.03l23.83,22.03c.23.22.25.58.03.81-.11.12-.27.18-.42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m347.96,333.01c-.27,0-.52-.2-.57-.48-.05-.31.16-.61.47-.66l15.53-2.65c.31-.05.61.16.66.47.05.31-.16.61-.47.66l-15.53,2.65s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m385.49,232.01s5.54,2.65,5.82,2.69c.39.05.79-.37.79-.37,0,0,.44.23.88.17.44-.07,3.25-2.14,3.25-2.14,0,0,2.79.2,3.09.1,1.61-.55.65-2.11.65-2.11-1.86.12-3.93-.42-4.62-.87-.68-.45-5.88-4.43-6.43-4.49-.55-.06-4,.33-4.71,1.3-2.44,3.31,1.27,5.74,1.27,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m389.2,224.94l4.06-.36.78.13h0s.13.09.21.13l.26.14c.18.09.37.17.56.24.38.15.77.25,1.15.32.77.13,1.53.07,2.2-.3l.04-.02c.38-.21.87-.07,1.08.31.18.32.11.71-.14.96-.42.41-.94.74-1.49.96-.55.22-1.13.35-1.71.41-.57.05-1.14.04-1.7-.02-.28-.03-.56-.07-.83-.13l-.42-.09c-.15-.04-.26-.06-.46-.13h0s.78.13.78.13l-4.05.48c-.87.1-1.65-.52-1.76-1.38-.1-.87.52-1.65,1.38-1.76.01,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m326.99,281.37c2.83,9.98,15.12,35.87,15.02,41.33l8.8-2.6s-4.4-21.13-9.33-41.25l-14.5,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m285.22,187.24c-1.77,3.81.62,9.14,9.04,12.78,8.42,3.64,6.6-12.78,6.6-12.78h-15.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m328.04,284.63s7.15-3.72,12.21-4.41c5.06-.68-13.55,0-13.55,0,0,.69,1.34,4.41,1.34,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m292.85,189.89c-7.63,5.24-19.98,23.84,0,39.04,7.33,5.58,15.84,19.06,23.67,33.89,3.48,6.59,9.04,20.11,9.04,20.11,5.86-2.25,17.05-2.89,17.05-2.89-.85-5.64-2.77-15.82-5-23.04-4.42-14.34-16.34-46.78-23.77-57.56l-20.99-9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m333.21,281.65c-.26,0-.5-.18-.56-.44-6.37-27.2-16.8-44.33-24.4-56.84-7.69-12.65-12.34-20.28-6.76-28.42.18-.26.54-.33.8-.15.26.18.33.54.15.8-5.15,7.52-.66,14.92,6.8,27.17,7.65,12.58,18.12,29.8,24.54,57.18.07.31-.12.62-.43.69-.04.01-.09.02-.13.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m335.92,281.36c-.26,0-.5-.18-.56-.45-6.88-30.42-17.52-48.08-24.55-59.78-6.85-11.39-10.63-17.66-5.3-25.2.18-.26.54-.32.8-.14.26.18.32.54.14.8-4.9,6.92-1.26,12.97,5.34,23.94,7.08,11.75,17.77,29.52,24.69,60.11.07.31-.12.62-.43.69-.04,0-.09.01-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m300.29,227.88c-15.07-13.76-8.86-28.84-1.27-35.18l-6.17-2.81c-7.63,5.24-19.98,23.84,0,39.04,7.33,5.58,15.84,19.06,23.67,33.89,3.48,6.59,9.04,20.11,9.04,20.11.86-.33,2.63-.82,3.67-1.08-9.91-29.85-22.13-47.75-28.94-53.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m348.33,195.95c1.12.9,5.22.04,11.03-4.33,5.81-4.38-2.84-7.61-2.84-7.61l-8.19,11.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m318.64,207.97c-1.71-3.47-3.34-6.42-4.79-8.53l-20.99-9.55c.81,2.12,9.01,15.8,25.78,18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m346.21,153.93c-39.91-2.08-60.99,33.31-60.99,33.31,9.76,0,24.12,22.69,41.34,11.93,2.44-3.12-2.08-3.62.02-5.92,2.11-2.3,20.97-5.15,25.47-11.32,4.5-6.17-5.85-27.99-5.85-27.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m387.26,225.13l-34.59-66.71s-16.2-4.32-13.57,9.78c3.79,20.34,24.21,44.28,45.56,63.1l2.6-6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m366.48,185.06s-11.63,7.74-13.24,12.49l-3.27-4.75,16.51-7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m352.33,182.36c.23-.32.16-1.12.34-1.51l-14.74-17.89c-1.61,5.77-4.94,16.58-3.34,27.27,0,0,15.11-4.27,17.74-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m356.96,203.15c-.78,0-1.47-.41-1.9-.95-.72-.9-.72-2.02-.01-2.73.22-.22.59-.22.81,0,.22.22.22.59,0,.81-.33.33-.18.85.1,1.2.33.42.97.75,1.68.3.27-.17.62-.09.79.18.17.27.09.62-.18.79-.44.28-.87.39-1.29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m327.77,283.83c3.53,10.43,12.85,30.62,14.1,37.51l1.94-.18-14.38-38.23-1.66.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m373.68,324.02c-.43-4.02-6.23-2.53-9.14-3.25-3.92-.97-13.3-5.95-13.3-5.95,0,0-2.68.35-2.96,1.66-.06.3.62,1.11.62,1.11,0,0-1.46,1.98-3.3,2.3-3.07.55-4.53-1.07-4.94-.62-1.77,1.93.05,9.09.05,9.09l26.49-1.25,6.48-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m373.68,324.02c-15.6,3.77-22.37.56-32.97,4.35l.62,3.49c.12.7.79,1.16,1.49,1.04l25.43-4.54s5.63-1.42,5.42-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m344.28,331.12l7.04-1.26c.5-.09.81-.64.71-1.24v-.02c-.11-.6-.6-1.01-1.1-.92l-7.04,1.26c-.5.09-.81.64-.71,1.24v.02c.11.6.6,1.01,1.1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m361.98,322.6c-.1,0-.2-.03-.29-.08-.27-.16-.36-.51-.2-.79l1.02-1.74c.16-.27.51-.37.79-.2.27.16.36.51.2.79l-1.02,1.74c-.11.18-.3.28-.5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m358.07,321.01c-.1,0-.2-.03-.29-.08-.27-.16-.36-.51-.2-.79l1.02-1.74c.16-.27.51-.37.79-.2.27.16.36.51.2.79l-1.02,1.74c-.11.18-.3.28-.5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m354.65,319.38c-.1,0-.2-.03-.29-.08-.27-.16-.36-.51-.2-.79l1.02-1.74c.16-.27.51-.37.79-.2.27.16.36.51.2.79l-1.02,1.74c-.11.18-.3.28-.5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m355.67,317.65s-.05,0-.08,0c-.16-.02-.3-.11-.39-.24-.86-1.24-1.01-4.1-.29-5.48.43-.82,1.06-.94,1.39-.94.06,0,.13,0,.19.01.61.08,1.05.48,1.24,1.13.45,1.55-.6,4.49-1.69,5.39-.1.09-.23.13-.37.13Zm.65-5.52c-.1,0-.24.03-.39.33-.42.81-.39,2.44-.1,3.51.58-1.01,1.05-2.69.81-3.52-.08-.29-.21-.3-.28-.31,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m355.47,317.99c-.07,0-.13-.01-.2-.04-2.09-.77-3.53-4.37-2.92-6.22.1-.3.42-.47.72-.37.3.1.47.42.37.72-.44,1.34.74,4.24,2.23,4.79.3.11.45.44.34.74-.09.23-.31.37-.54.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m327.5,287.21c-.19,0-.38,0-.57-.03-.32-.03-.55-.31-.52-.63.03-.32.32-.55.63-.52.94.09,1.86-.11,2.83-.32,1.65-.36,3.53-.77,5.58.4.28.16.37.51.22.78-.16.28-.51.37-.78.22-1.67-.95-3.17-.62-4.77-.27-.84.18-1.71.37-2.62.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m328.32,290.44c-.19,0-.38,0-.57-.03-.32-.03-.55-.31-.52-.63.03-.32.31-.55.63-.52.94.09,1.86-.11,2.83-.32,1.65-.36,3.53-.77,5.58.4.28.16.37.51.22.78-.16.28-.51.37-.78.22-1.67-.95-3.17-.62-4.77-.27-.84.18-1.71.37-2.62.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m329.38,293.46c-.19,0-.38,0-.57-.03-.32-.03-.55-.31-.52-.63.03-.32.32-.55.63-.52.93.09,1.86-.11,2.83-.32,1.65-.36,3.53-.77,5.58.4.28.16.37.51.22.78-.16.28-.51.37-.78.22-1.67-.95-3.18-.62-4.77-.27-.84.18-1.71.37-2.62.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m373.12,217.09c-.12,0-.24-.04-.34-.11-1.07-.78-2.1-.68-3.29-.56-.76.08-1.55.16-2.36-.02-.31-.07-.51-.37-.44-.68.07-.31.37-.51.68-.44.64.13,1.31.07,2.01,0,1.24-.13,2.66-.27,4.08.77.26.19.31.55.13.8-.11.15-.29.24-.46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m374.9,220.13c-.12,0-.24-.04-.34-.11-1.07-.78-2.1-.68-3.29-.56-.76.08-1.55.15-2.36-.02-.31-.07-.51-.37-.44-.68.07-.31.37-.51.68-.44.64.13,1.31.07,2.01,0,1.24-.13,2.66-.27,4.08.77.26.19.31.55.13.8-.11.15-.29.24-.46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m377.99,222.98c-.12,0-.24-.04-.34-.11-1.07-.78-2.1-.68-3.29-.56-.76.08-1.55.16-2.36-.02-.31-.07-.51-.37-.44-.68.06-.31.37-.51.68-.44.64.13,1.31.07,2.01,0,1.24-.13,2.66-.27,4.08.77.26.19.31.55.13.8-.11.15-.29.24-.46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m343.44,165.94c-8.05,7.55-27.83,8.99-41.5,2.53l-4.71,3.7c23.3,10.54,40.41,4.76,56.13-7.53l-9.92,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m337.9,169.11c1.27,8.08,4.71,18.22,10.43,26.85,4.53-3.68,18.15-10.89,18.15-10.89h0c-5.31-10.1-10.35-30.59-20.27-31.1,0,0-10.72-.27-8.3,15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m372.88,133.22s5.69-.1,3.92-2.82c-1.02-1.57-18.01-8.33-24.54-2.51-5.62,5.01-.92,16.05-.92,16.05l3.44.74c-1.51,1.19-3.28,1.44-3.28,1.44,1.18,6.47,6.72,18.25,14.97,15.93,5.66-1.6,4.22-9.86,3.45-12.24-1.27-1.27-3.97,2.85-6.12,3.35-1.1.26-10.44-9.31-5.74-20.6,5.44,5.44,18.54,5.74,19.21,3.49.46-1.54-4.4-2.82-4.4-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m358.02,145.91c-.34,2-2.23,3.35-4.23,3.01s-3.35-2.23-3.01-4.23,2.23-3.35,4.23-3.01c2,.34,3.35,2.23,3.01,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m356.17,145.6c-.16.98-1.09,1.64-2.07,1.47-.98-.16-1.64-1.09-1.47-2.07s1.09-1.64,2.07-1.47,1.64,1.09,1.47,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m364.68,127.08c-1.96,0-3.43-.16-3.58-.18-.32-.04-.54-.32-.5-.64.04-.32.32-.54.64-.51.09.01,8.94.99,12.37-1.92.24-.2.6-.17.81.07.21.24.17.6-.07.81-2.33,1.97-6.6,2.37-9.67,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m359.57,127.23c-.31,0-.56-.24-.57-.55-.01-.32.23-.58.55-.6,3.57-.14,6.22-.85,7.65-2.07.24-.21.61-.17.81.07.21.24.17.6-.07.81-1.65,1.4-4.46,2.19-8.35,2.34,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m264.41,186.07c-.66,0-1.29-.38-1.58-1.02-.39-.87,0-1.89.88-2.27,2.95-1.31,6.54-1.33,10-1.35,6.24-.03,12.14-.06,15.07-6.91.37-.88,1.38-1.28,2.26-.91.87.37,1.28,1.39.91,2.26-3.81,8.93-11.8,8.97-18.22,9-3.25.02-6.33.03-8.62,1.05-.23.1-.46.15-.7.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m497.9,331.69c-.14,0-.28-.05-.39-.15l-23.83-22.03c-.23-.22-.25-.58-.03-.81.22-.23.58-.25.81-.03l23.83,22.03c.23.22.25.58.03.81-.11.12-.27.18-.42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m478.38,312.47c.31-.93,9.26-4.48,11.58-2.8l-7.32,4.3-4.27-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m530.58,223.64l4.06-.36.78.13h0s.13.09.21.13l.26.14c.18.09.37.17.56.24.38.15.77.25,1.15.32.77.13,1.53.07,2.2-.3l.04-.02c.38-.21.87-.07,1.08.31.18.32.11.71-.14.96-.42.41-.94.74-1.49.96-.55.22-1.13.35-1.71.41-.57.05-1.14.04-1.7-.02-.28-.03-.56-.07-.84-.13l-.42-.09c-.15-.04-.26-.06-.46-.13h0s.78.13.78.13l-4.05.48c-.87.1-1.65-.52-1.76-1.38-.1-.87.52-1.65,1.38-1.76.01,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m469.27,175.8c.26,7.5,8.88,30.66,18.25,37.79,18.23,13.87,42.08,14.99,42.08,14.99l3.33-3.86c-6.64-1.98-31.53-16.44-35.53-21.17-2.89-3.43-3.02-20.75-5.62-28.72-2.6-7.97-10.3-14.19-17.4-10.35-7.09,3.84-5.12,11.31-5.12,11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m489.19,214.81c2.7,1.87,5.55,3.44,8.47,4.75,4.22-5.97,4.61-11.54,4.7-12.39l-13.95,5.93s.29.71.78,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m491.78,174.83c-2.6-7.97-10.3-14.19-17.4-10.35-7.09,3.84-5.12,11.31-5.12,11.31.26,7.5,8.23,31.5,17.6,38.63,2.03,1.54,6.37,4.1,6.37,4.1,7.59-7.1,9-12.02,9-12.02-2.13-1.29-3.73-2.44-4.48-3.33-2.89-3.43-3.38-20.37-5.98-28.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m493.24,219.81c-.34,0-.67-.13-.93-.39-.49-.51-.47-1.32.04-1.81.09-.09.23-.22.4-.37,1.66-1.53,6.7-6.19,8.09-10.62.21-.68.93-1.05,1.61-.84.68.21,1.05.93.84,1.61-1.6,5.08-7.02,10.09-8.8,11.73-.16.14-.28.26-.37.34-.25.24-.57.36-.89.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m419.43,221.96c-.29,1.91,2.75,4.33,11.06,5.06,8.31.73,9.32-18.65,9.32-18.65l-20.38,13.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m426.47,203.92c-.72,2.15-5.76,19.52,9.33,26.84,19.23,9.33,39.49,27.5,39.49,27.5-5.48,20.1-.58,31.96,4.59,54.93l8.12-1.99c-.24-25.36,7.44-45.02,7.96-52.8.91-13.6-30.74-50.04-30.74-50.04l-38.76-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m480.56,316.23c1.53,4.19,3.03,8.33,4.33,12.27l5.81-1.81c-.84-1.08-2.71-6.16-2.4-13.09l-7.74,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m480.53,316.13c1.35,3.71,2.97,8.15,4.13,11.65l.71-.24-2.85-10.23c1.66.06,4.64-.64,5.71-1.23.03-1.39.08-2.39.15-4.01l-7.85,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m458.56,226.85c-.18,0-.36-.09-.47-.25-.18-.26-.11-.62.15-.8.26-.18.55-.37.87-.58,2.94-1.92,7.87-5.15,6.4-11.84-.07-.31.13-.62.44-.68.31-.07.62.13.68.44,1.64,7.47-3.91,11.1-6.89,13.05-.31.2-.59.39-.84.56-.1.07-.21.1-.33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m481.93,314.25l3.25-1.1c1.25-1.29,1.14-1.93,1.14-1.93-2.68.83-6.27.51-6.81.43.14.91.21,1.48.52,2.33l1.9.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m489.25,326.05c-.43.31-1.57.71-2.55.62-2.34-.21-3.1-.89-3.31-.76-.21.12-.79,3.01.16,4.62s6.92-.96,6.92-.96l-1.22-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m505.28,326.22c-.06-.25-.75-.75-2.07-.65-7.12.54-12.65-3.42-12.65-3.42,0,0-2.45,3.03,1.05,7.24l6.58-1.03,7.09-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m496.8,328.39c.32-.37,2.15-2.88.98-3.45-2.63-.77-5.3-2.48-6.37-1.55-1.07.93-2.65,3.67-4.14,3.96-1.48.29-4.11-.75-4.11-.75,0,0-.17.86-.14,1.43,0,0,5.79,1.4,6.53,1.66.75.26,7.24-1.3,7.24-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m505.28,326.22c.67.09,1.07,2.09,1.07,2.09,0,0-4.82,2.14-9.22,2.76-7.59,1.07-12.9,2.15-13.06,1.71-.16-.44-.52-2.25-.52-2.25,0,0,7.73-1.01,10.52-1.56,5.67-1.11,11.21-2.75,11.21-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m490.9,323.92c.18-.21.35-.39.52-.53,1.07-.93,3.73.78,6.37,1.55.43.21.53.74.19,1.54-.87-.11-4.52-1.17-7.07-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m494.74,325.31c-.07,0-.13-.01-.2-.04-.3-.11-.45-.44-.34-.74l.29-.79c.11-.3.44-.45.74-.34.3.11.45.44.34.74l-.29.79c-.09.23-.31.38-.54.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m496.97,326.15c-.05,0-.1,0-.16-.02-.31-.09-.48-.4-.4-.71l.23-.81c.09-.31.41-.49.71-.4.31.09.48.4.4.71l-.23.81c-.07.25-.3.42-.55.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m481.16,312.28c-5.17-22.97-4.39-36.75,1.09-56.85,0,0-14.55-17.52-33.79-26.85-11.66-5.66-11.3-17.31-10.2-23.31l-11.79-1.35c-.72,2.15-5.76,19.52,9.33,26.84,19.23,9.33,39.49,27.5,39.49,27.5-5.48,20.1-.58,31.96,4.59,54.93l1.28-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m482.5,312.97c-.25,0-.48-.17-.55-.42-4.06-14.51-4.19-39-.3-57.05-3.42-7.36-10.66-15.05-17.06-21.83-7.89-8.37-14.7-15.59-13.56-20.86.07-.31.37-.51.68-.44.31.07.51.37.44.68-1.02,4.67,5.92,12.03,13.27,19.82,6.51,6.91,13.89,14.73,17.35,22.32.05.11.07.24.04.36-3.9,17.91-3.8,42.28.24,56.68.09.31-.09.62-.4.71-.05.01-.1.02-.16.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m425.88,206.08c-.79,3.45-1.67,10.08,1.1,16.02,6.39.49,28.17-1.68,39.07-8.68,8.49-5.45-22.64-6.93-40.18-7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m419.43,221.96c7.25-6.05,33.75,0,51.41-11.06,11.37-8.66,22.08-40.43,22.08-40.43l-6.17-10.34c-54.34,16.94-63.02,38.47-67.32,61.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m465.12,171.51c-2.16,5.36-3.96,25.95,1.17,41.75,0,.01.02.02.03.03,1.56-.69,3.08-1.48,4.53-2.39,2.96-2.25,5.88-6.08,8.57-10.5l-14.3-28.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m465.1,176.3c.26,7.5,8.88,30.66,18.25,37.79,18.23,13.87,42.08,14.99,42.08,14.99l3.33-3.86c-6.64-1.98-31.53-16.44-35.53-21.17-2.89-3.43-3.02-20.75-5.62-28.72-2.6-7.97-10.3-14.19-17.4-10.35-7.09,3.84-5.12,11.31-5.12,11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m485.02,215.31c2.7,1.87,5.35,3.64,8.26,4.96,4.22-5.97,4.81-11.75,4.91-12.59l-13.95,5.93s.29.71.78,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m487.62,175.33c-2.6-7.97-10.3-14.19-17.4-10.35-7.09,3.84-5.12,11.31-5.12,11.31.26,7.5,8.23,31.5,17.6,38.63,2.03,1.54,6.37,4.1,6.37,4.1,7.59-7.1,9-12.02,9-12.02-2.13-1.29-3.73-2.44-4.48-3.33-2.89-3.43-3.38-20.37-5.98-28.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m489.07,220.31c-.34,0-.67-.13-.93-.4-.49-.51-.47-1.32.04-1.81.09-.09.23-.21.4-.37,1.66-1.53,6.7-6.19,8.1-10.62.21-.68.93-1.05,1.61-.84.68.21,1.05.93.84,1.61-1.6,5.08-7.02,10.09-8.8,11.73-.16.14-.28.26-.36.34-.25.24-.57.36-.89.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m527.49,232.01s5.54,2.65,5.82,2.69c.39.05.79-.37.79-.37,0,0,.44.23.88.17.44-.07,3.25-2.14,3.25-2.14,0,0,2.79.2,3.09.1,1.61-.55.65-2.11.65-2.11-1.86.12-3.93-.42-4.62-.87-.68-.45-5.88-4.43-6.43-4.49-.55-.06-4,.33-4.71,1.3-2.44,3.31,1.27,5.74,1.27,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m531.21,224.94l4.06-.36.78.13h0s.13.09.21.13l.26.14c.18.09.37.17.56.24.38.15.77.25,1.15.32.77.13,1.53.07,2.2-.3l.04-.02c.38-.21.87-.07,1.08.31.18.32.11.71-.14.96-.42.41-.94.74-1.49.96-.55.22-1.13.35-1.71.41-.57.05-1.14.04-1.7-.02-.28-.03-.56-.07-.84-.13l-.42-.09c-.15-.04-.26-.06-.46-.13h0s.78.13.78.13l-4.05.48c-.87.1-1.65-.52-1.76-1.38-.1-.87.52-1.65,1.38-1.76.01,0,.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m481.17,214.17h-.02c-1.41-.04-2.32-.47-2.72-1.26-.38-.77-.2-1.79.51-2.79.18-.26.54-.32.8-.14.26.18.32.54.14.8-.44.63-.61,1.25-.42,1.61.19.38.8.6,1.72.63.32,0,.57.27.56.59,0,.31-.26.56-.57.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m490.14,333.01c-.27,0-.52-.2-.57-.48-.05-.31.16-.61.47-.66l15.53-2.65c.31-.05.61.16.66.47.05.31-.16.61-.47.66l-15.53,2.65s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m478.38,312.47c.17,1.88,1.13,3.64,1.13,3.64,0,0,6.3,1.04,9.72-1.86,1.53-1.24.74-4.58.74-4.58,0,0-6.69,3.46-11.58,2.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m511.39,152.15s1.25,6.05.48,6.46c-.49.26-2.73-.36-2.73-.36l2.25-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m496.47,168.04s-.62,3.48-2.73,4.99l-.68-3.16,2.07-1.8,1.34-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m493.04,169.98c.47-.16,2.05-1.62,3.43-1.94,0,0-.61-3.21-2.01-4.82l-2.68,3.4,1.26,3.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "487.44 160.29 495.97 155.53 502.48 159.97 492.49 170.73 489.31 168.03 487.44 160.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m493.79,155.53c-.86,2.8,1.15,8.41,2.69,10.91h0l3.57-3.84-6.26-7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m506.73,164.75c1.62-.32,6.45-14.49,4.7-19.72-5.88-17.6-25.22,2.57-16.16,13.47,5.57,6.71,10.6,6.41,11.46,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m509.9,146.15c-.66-1.97-1.5-3.43-2.46-4.44l-10.25,1.5s2.1,5.36,2.54,3.91c.44-1.45.54-2.62,1.89-2.28,1.85.47,4.13,5.84,8.59,4.95.09-1.35-.03-2.79-.31-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m495.19,141.42s-.04,0-.07,0c-3.04-.35-4.51-3.24-4.72-4.98-.04-.31.18-.6.5-.64.32-.04.6.19.64.5.14,1.18,1.24,3.7,3.71,3.98.32.04.54.32.5.64-.03.29-.28.51-.57.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m494.53,166.43c0,1.4-3.71,9.83-3.71,9.83l.62-7.97,3.09-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m485.21,160.63c-.06.93,1.4,9.35,5.61,15.62,1.34-3.5,2.11-5.78,2.11-5.78l-6.17-10.34c-.52.16-1.03.33-1.54.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m485.51,194.65c-1.45,1.88-3.4,3.5-5.66,4.62-2.26,1.12-4.81,1.72-7.35,1.81-1.27.04-2.54-.04-3.79-.22-.62-.08-1.24-.21-1.85-.34l-.11-.02-.16-.04-.21-.06-.42-.11c-.3-.09-.65-.21-.97-.32-2.44-.89-4.47-2.22-6.31-3.53-1.84-1.32-3.49-2.65-5.06-3.84-1.57-1.2-3.04-2.28-4.43-3.19-1.39-.91-2.69-1.66-3.86-2.24-1.17-.58-2.22-1-3.1-1.31-.87-.3-1.57-.5-2.04-.62-.48-.12-.73-.18-.73-.18l-2.91-3.49,4.15-1.52s.31.09.88.26c.57.17,1.4.44,2.43.86,1.03.42,2.25.97,3.58,1.71,1.33.73,2.76,1.65,4.24,2.72,1.48,1.07,2.99,2.29,4.54,3.59,1.54,1.3,3.12,2.67,4.77,3.95,1.65,1.28,3.39,2.49,5.23,3.24.22.08.4.16.65.25l.41.13.21.06.05.02h.03c-.1-.02-.02,0-.03,0l.1.03c.51.14,1.02.27,1.54.37,1.04.21,2.09.34,3.14.36,2.1.04,4.19-.33,6.08-1.13,1.89-.8,8.42-3.69,6.96-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m492.65,172.47s-.04.06-.13.17c-.04.06-.09.13-.16.21-.04.07-.09.16-.15.25-.23.39-.55,1.08-.83,2-.56,1.86-.97,4.69-1.22,8.13-.02.21-.03.43-.05.65-.02.23-.04.46-.06.7-.03.43-.12.96-.19,1.46-.18.98-.43,1.98-.78,2.99-.71,2.01-1.84,4.03-3.43,5.8-1.58,1.77-3.65,3.24-5.99,4.18-2.34.95-4.92,1.35-7.47,1.26-1.27-.05-2.53-.23-3.76-.5-.62-.13-1.22-.3-1.82-.47l-.11-.03-.16-.05-.2-.07-.41-.14c-.29-.11-.63-.26-.94-.39-2.36-1.07-4.29-2.55-6.03-3.99-1.74-1.45-3.28-2.9-4.76-4.21-1.47-1.31-2.86-2.51-4.18-3.51-1.32-1.01-2.56-1.86-3.68-2.52-1.13-.67-2.14-1.16-2.99-1.54-.85-.37-1.53-.62-1.99-.77-.47-.15-.72-.23-.72-.23l-2.64-3.7,4.25-1.21s.3.11.86.32c.56.21,1.37.55,2.36,1.04.99.49,2.17,1.13,3.44,1.97,1.27.83,2.63,1.85,4.03,3.03,1.4,1.17,2.81,2.51,4.26,3.92,1.44,1.41,2.92,2.89,4.47,4.3,1.55,1.4,3.19,2.73,4.97,3.62.21.1.39.19.63.3l.4.16.2.08.05.02h.03c-.1-.03-.01,0-.03,0l.09.03c.5.18,1,.35,1.51.49,1.02.28,2.06.49,3.1.59,2.09.2,4.21-.01,6.15-.67,1.94-.66,3.71-1.76,5.11-3.15,1.41-1.4,2.47-3.06,3.19-4.77.35-.86.63-1.73.84-2.58.08-.43.18-.81.24-1.28.03-.22.06-.43.09-.64.03-.22.06-.44.09-.66.46-3.49,1.05-6.4,1.78-8.4.35-1.01.72-1.77,1.07-2.31.09-.13.17-.25.24-.35.06-.08.12-.15.16-.2.09-.11.13-.17.13-.17l1.13.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 491.9,
    cy: 171.34,
    r: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m488.03,158.62s-1.13,1.1-2.82,2.01c.29,3.19,5.46,12.18,5.46,12.18,0,0,3.69-5.68,3.86-6.26.17-.58-2.94-6.47-6.5-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m494.92,140.55s5.12-5.66,15.15-6.59c9.43-.88,11.36,7.18,2.05,9.21,0,0,3.49,4.45-.32,5.06-2.92.47-8.18-3.81-10.4-3.73,0,0,3.61,4.18.94,4.76-2.66.59-6.84-4.29-6.84-4.29,0,0,4,10.59-5.27,13.76,1.42-2.45-3.62-10.43-2.85-14.19.59-2.85,3.57-5.27,7.53-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m498.37,151.88c-.44,1.72-2.19,2.76-3.91,2.32-1.72-.44-2.76-2.19-2.32-3.91.44-1.72,2.19-2.76,3.91-2.32,1.72.44,2.76,2.19,2.32,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m496.78,151.48c-.21.84-1.07,1.35-1.91,1.13-.84-.21-1.35-1.07-1.13-1.91s1.07-1.35,1.91-1.13c.84.21,1.35,1.07,1.13,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m496.83,142.61c-.14,0-.28-.05-.39-.16-1.68-1.58-2.46-3.79-2.25-6.4.24-2.97,1.75-5.89,3.02-6.75.26-.18.62-.11.8.15.18.26.11.62-.15.8-.91.62-2.3,3.16-2.52,5.89-.12,1.57.1,3.79,1.9,5.47.23.22.24.58.02.81-.11.12-.27.18-.42.18Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.43a01b71ac49a5962525129f2bdfc3ab.svg";
export { ForwardRef as ReactComponent };